import { createFileRoute } from '@tanstack/react-router';

import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout',
)({
  loader: async ({ params: { abstractId, citationId }, context: { queryClient } }) => {
    const citation = await queryClient.ensureQueryData(getCitationOptions(abstractId, citationId));
    return {
      citation,
      breadcrumb: citation?.title ?? '',
    };
  },
});
